export default __webpack_public_path__ + "media/components/Header/Images/Text_bigger-5ede57055335fc8028d756c915ce6ea9.svg";